// src/store/index.js (Fixed - only one default export)
import { createStore } from 'vuex'
import auth from './modules/auth'
import users from './modules/users'

export default createStore({
  state: {
    loading: false,
    error: null,
    success: null
  },

  mutations: {
    SET_LOADING(state, loading) {
      state.loading = loading
    },

    SET_ERROR(state, error) {
      state.error = error
    },

    SET_SUCCESS(state, success) {
      state.success = success
    },

    CLEAR_MESSAGES(state) {
      state.error = null
      state.success = null
    }
  },

  actions: {
    setLoading({ commit }, loading) {
      commit('SET_LOADING', loading)
    },

    setError({ commit }, error) {
      commit('SET_ERROR', error)
    },

    setSuccess({ commit }, success) {
      commit('SET_SUCCESS', success)
    },

    clearMessages({ commit }) {
      commit('CLEAR_MESSAGES')
    }
  },

  getters: {
    loading: (state) => state.loading,
    error: (state) => state.error,
    success: (state) => state.success
  },

  modules: {
    auth,
    users
  }
})
